<template>
  <div class="chat">
    <div class="msg_list" ref="chatRef">
      <div style="padding: 15px">
        <div class="one_msg" v-for="item in msgListCopy" :key="item.id">
          <el-image
            class="avatar"
            :src="item.formAvatar"
            fit="cover"
          ></el-image>
          <div class="right">
            <div class="name_row">
              <span class="name">{{ item.formName }}</span>
              <span v-show="item.toUserId" class="private">私聊</span>
              <span v-show="item.toUserId">{{ item.toName }}</span>
              <span class="time">{{
                formatDate(item.createTime, "MM-DD HH:mm")
              }}</span>
            </div>
            <p class="content">{{ item.msg }}</p>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 0 15px; height: 180px">
      <el-button class="forbid_btn" type="text" @click="handleForbid">{{
        chatDisabled ? "取消禁言" : "全体禁言"
      }}</el-button>
      <el-input
        type="textarea"
        :rows="4"
        resize="none"
        @focus="onFocus"
        @keydown.native="textareaKeydown"
        placeholder="我来说两句"
        v-model="msgContent"
      >
      </el-input>
      <el-select
        class="select_sb"
        v-model="toUserId"
        filterable
        placeholder="请选择"
      >
        <el-option :key="null" label="所有人" :value="null">所有人</el-option>
        <el-option
          v-for="item in studentList"
          :key="item.userId"
          :label="item.name + ' ' + item.sno"
          :value="item.userId"
        >
        </el-option>
      </el-select>
      <el-button class="save_btn" type="primary" @click="handleSend"
        >发送</el-button
      >
    </div>
  </div>
</template>

<script>
import { classInfo, editChatState } from "@/api/class";
import { chatList, sendChat } from "@/api/chat";
import { formatDate } from "@/utils/index";
export default {
  name: "chat",
  data() {
    return {
      formatDate,
      msgList: [],
      msgContent: "",
      msgType: "TEXT",
      toUserId: null,
      subObj: Object,
      minMsgId: null,
      loadMore: false,
      noMore: false,
      chatDisabled: false,
    };
  },
  created() {
    this.subscribe();
    this.getChatHistory();
    this.getClassInfo();
  },
  activated() {
    this.msgNum = 0;
    this.$emit("updateMsgNum", this.msgNum);
  },
  mounted() {
    this.$refs.chatRef.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    stompClient() {
      return this.$store.state.stompClient;
    },
    msgListCopy() {
      return [...this.msgList].reverse();
    },
    studentList() {
      return this.$store.state.studentList;
    },
  },
  watch: {
    msgList: {
      handler() {
        if (this.loadMore) return;
        let scrollHeight = this.$refs.chatRef.scrollHeight;
        this.$nextTick(() => {
          let top = scrollHeight - this.$refs.chatRef.offsetHeight;
          if (
            top == this.$refs.chatRef.scrollTop ||
            this.$refs.chatRef.scrollTop == 0
          )
            this.$refs.chatRef.scrollTop = this.$refs.chatRef.scrollHeight;
        });
      },
      deep: true,
    },
  },
  methods: {
    // 滚动条监听
    handleScroll() {
      let scrollTop = this.$refs.chatRef.scrollTop;
      if (scrollTop <= 0) {
        this.loadMore = true;
        if (this.noMore) this.$message.warning("没有更多消息了");
        else this.getChatHistory(true);
      }
    },
    // 消息历史记录
    getChatHistory(refresh) {
      // this.$loading.show();
      chatList({
        minMsgId: this.minMsgId,
        classId: this.$route.query.id,
        classChapterId: this.$route.query.classChapterId,
      }).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          if (refresh && res.data.length <= 0) {
            this.$message.warning("没有更多消息了");
            this.noMore = true;
            return;
          }
          this.msgList = refresh ? this.msgList.concat(res.data) : res.data;
          this.minMsgId = res.data[res.data.length - 1].msgId;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 订阅聊天频道
    subscribe() {
      let that = this;
      let classId = this.$route.query.id;
      this.subObj = this.stompClient.subscribe(
        `/topic/class/chat/${classId}`,
        (msg) => {
          console.log(msg, "topic");
          this.msgNum++;
          this.$emit("updateMsgNum", this.msgNum);
          that.msgList.unshift(JSON.parse(msg.body));
        }
      );
      this.subObj = this.stompClient.subscribe(
        `/user/queue/class/chat/${classId}`,
        (msg) => {
          console.log(msg, "topic");
          this.msgNum++;
          this.$emit("updateMsgNum", this.msgNum);
          that.msgList.unshift(JSON.parse(msg.body));
        }
      );
    },
    // 输入框聚焦
    onFocus() {
      this.$refs.chatRef.scrollTop = this.$refs.chatRef.scrollHeight;
    },
    // 发送消息
    handleSend() {
      this.loadMore = false;
      sendChat({
        classChapterId: this.$route.query.classChapterId,
        classId: this.$route.query.id,
        msgType: this.msgType,
        toUserId: this.toUserId,
        msg: this.msgContent,
      }).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.msgContent = "";
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //监听按键操作
    textareaKeydown(event) {
      if (event.ctrlKey && event.keyCode === 13) {
        //ctrl+enter
        this.insertVariable();
      } else if (event.keyCode === 13) {
        //enter
        this.handleSend();
        event.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
    },
    // 班级详情
    getClassInfo() {
      classInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.chatDisabled = res.data.chatDisabled;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 禁言与取消
    handleForbid() {
      editChatState(this.$route.query.id).then((res) => {
        this.$loading.show();
        if (res.code == 0) {
          this.$loading.hide();
          this.$message.success(
            this.chatDisabled ? "已取消禁言" : "全体已禁言"
          );
          this.getClassInfo();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.chat {
  height: 100%;
  .msg_list {
    margin-bottom: 10px;
    height: calc(100% - 180px - 15px);
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .one_msg {
      padding: 4px 0;
      .avatar {
        margin-right: 10px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        text-align: center;
      }
      .right {
        display: inline-block;
        padding-bottom: 8px;
        width: 260px;
        border-bottom: solid 1px #969696;
        vertical-align: top;
        .name_row {
          font-size: 14px;
          color: #969696;
          line-height: 1;
          overflow: hidden;
          .private {
            margin: 0 5px;
            font-size: 12px;
            color: #f56c6c;
          }
          .time {
            float: right;
            font-size: 12px;
          }
        }
        .content {
          margin-top: 5px;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }

  ::v-deep .el-textarea__inner {
    font-family: inherit;
  }

  .forbid_btn {
    padding-top: 0;
    color: #f56c6c;
  }
  .select_sb {
    margin-top: 10px;
    width: 200px;
  }
  .save_btn {
    float: right;
    margin-top: 10px;
    width: 90px;
    border-color: #1890ff;
    background: #1890ff;
    border-radius: 4px;
  }
}
</style>